// src/lib/calendly.js
const CALENDLY_LINK = "https://calendly.com/ethirapropertydata/30min";

function ensureCalendly() {
  if (typeof window === "undefined") return null;
  return window.Calendly || null;
}

/** Open the Calendly pop-up with pre-filled answers + UTM. */
export function openCalendlyPopup({
  name,
  email,
  a1, // Phone (if you added it as a custom question)
  a2, // Amount to invest
  a3, // When are you planning to invest?
  utm = { utmSource: "landing", utmMedium: "cta", utmCampaign: "guide" },
  url = CALENDLY_LINK,
} = {}) {
  const Calendly = ensureCalendly();
  if (!Calendly) {
    // Fallback: open plain link (no prefill/utm object support)
    const u = new URL(url);
    if (utm) {
      Object.entries(utm).forEach(([k, v]) => u.searchParams.set(k, v));
    }
    return window.open(u.toString(), "_blank", "noopener");
  }

  Calendly.initPopupWidget({
    url,
    prefill: {
      name: name || "",
      email: email || "",
      customAnswers: {
        ...(a1 ? { a1 } : {}),
        ...(a2 ? { a2 } : {}),
        ...(a3 ? { a3 } : {}),
      },
    },
    utm,
  });
}

/** Open Calendly pop-up with NO prefill (use for bottom CTAs). */
export function openCalendlyPopupNoPrefill({
  url = CALENDLY_LINK,
  utm = { utmSource: "landing", utmMedium: "cta", utmCampaign: "footer" },
} = {}) {
  const Calendly = ensureCalendly();
  if (!Calendly) {
    const u = new URL(url);
    if (utm) Object.entries(utm).forEach(([k, v]) => u.searchParams.set(k, v));
    return window.open(u.toString(), "_blank", "noopener");
  }
  Calendly.initPopupWidget({ url, utm });
}

/** Optional: a floating badge that’s always visible site-wide. */
export function initCalendlyBadge({
  url = CALENDLY_LINK,
  text = "Book a call",
  color = "#003366",
  textColor = "#ffffff",
  branding = true,
  prefill,
  utm,
} = {}) {
  const Calendly = ensureCalendly();
  if (!Calendly) return;

  Calendly.initBadgeWidget({
    url,
    text,
    color,
    textColor,
    branding,
    ...(prefill ? { prefill } : {}),
    ...(utm ? { utm } : {}),
  });
}
